<aside class="page-sidebar" [ngClass]="opensideBar ? 'open' : 'closed'">
    <div class="logo">
        <a (click)="navigation('/content-pool')" style="cursor:pointer">
            <img class="open-img" [src]="silverpushLogo" alt="silverpush" />
            <img class="close-img" [src]="silverpush" alt="silverpush" />

        </a>
    </div>
    <button class="sidebar-toggle no-btn t-right" data-tooltip="Expand/Collapse" (click)="toggleSidebar()">
        <i class="t-arrow" [style.transform]="opensideBar ? 'rotate(310deg)' : 'rotate(130deg)'"></i>
    </button>
    <ul class="sidebar-menu">
        <li (click)="navigation('/content-pool')" [attr.data-tooltip]="!opensideBar ? 'Content Pool' : null">
            <a [ngClass]="{'active': currentRoutePathObservable === 'content-pool'}">
                <img [src]="contentPool" alt="content-pool" />
                @if(opensideBar){
                  <span class="title">Content Pool</span>
                }
            </a>
        </li>

        @if(userData?.permissions_ids.includes(13)){
            <li (click)="navigation('segment/segment-listing')" [attr.data-tooltip]="!opensideBar ? 'Segment Listing' : null">
                <a [ngClass]="{'active': currentRoutePathObservable === 'segment/segment-listing'}">
                    <img [src]="segment" alt="segment" />
                    @if(opensideBar){
                    <span class="title">Segment Listing</span>
                    }
                </a>
            </li>
        }

         @if(userData?.permissions_ids.includes(15)){
            <li (click)="navigation('segment/segment-permission')" [attr.data-tooltip]="!opensideBar ? 'Segment Permission' : null">
                <a [ngClass]="{'active': currentRoutePathObservable === 'segment/segment-permission'}">
                    <img [src]="security" alt="segment" />
                    @if(opensideBar){
                    <span class="title">Segment Permission</span>
                    }
                </a>
            </li>
        }
     
        @if(userData?.permissions_ids.includes(5)){
            <li (click)="navigation('/user/user-listing')" [attr.data-tooltip]="!opensideBar ? 'User Management' : null">
                <a [ngClass]="{'active': currentRoutePathObservable === 'user/user-listing'}">
                    <img [src]="user" alt="user_management" />
                    @if(opensideBar){
                      <span class="title">User Management</span>
                    }
                </a>
            </li>
        }

    </ul>
</aside>